import {
    REPORTS_ADVERTISER_COMMISSION_REPORT_GET,
    REPORTS_ADVERTISER_COMMISSION_REPORT_GET_LOADING,
    REPORTS_PUBLISHER_COMMISSION_REPORT_GET,
    REPORTS_PUBLISHER_COMMISSION_REPORT_GET_LOADING,
} from '../actions/types';


import {
    AJAX_NOT_RUNNING,
} from '../services/config';

const initialState = {
    advertiserCommissionReportGet: [],
    advertiserCommissionReportGetLoading: AJAX_NOT_RUNNING,
    publisherCommissionReportGet: [],
    publisherCommissionReportGetLoading: AJAX_NOT_RUNNING,
};

export default function (state = initialState, action) {

    switch (action.type) {
        case REPORTS_ADVERTISER_COMMISSION_REPORT_GET:
            return {
                ...state,
                advertiserCommissionReportGet: action.payload
            };
        case REPORTS_ADVERTISER_COMMISSION_REPORT_GET_LOADING:
            return {
                ...state,
                advertiserCommissionReportGetLoading: action.payload
            };
        case REPORTS_PUBLISHER_COMMISSION_REPORT_GET:
            return {
                ...state,
                publisherCommissionReportGet: action.payload
            };
        case REPORTS_PUBLISHER_COMMISSION_REPORT_GET_LOADING:
            return {
                ...state,
                publisherCommissionReportGetLoading: action.payload
            };
        default:
            return state;
    }

}